import { CompletedExtractionType } from '../../types';
import { PageModeType } from '../../../../components/pdfViewer/types';
import ExtractionsHistory from '../extractionHistory';
import PagesModeControls from '../../../../components/pdfViewer/pagesModeControls';
import { FullPageNavigation } from '../../../../components/pdfViewer/pageNavigation';
import { Button } from 'semantic-ui-react';
import ScaleControl from '../../../../components/scaleControl';
import './styles.css';

type ExtractionHeaderPropsType = {
    pageMode: PageModeType;
    setPageMode: (mode: PageModeType) => void;
    completedExtractions: CompletedExtractionType[];
    currentPage: number;
    handleNextPage: () => void;
    handlePrevPage: () => void;
    handleSetPage: (page: number) => void;
    numberOfPages: number;
    screenshotsEnabled: boolean;
    toggleScreenshotsEnabled: () => void;
    scale: number;
    onScaleChange: (value: number) => void;
    thumbnailPanelVisible: boolean;
    toggleThumbnailPanel: () => void;
};

const ExtractionHeader = ({
    completedExtractions,
    pageMode,
    setPageMode,
    currentPage,
    handleNextPage,
    handlePrevPage,
    handleSetPage,
    numberOfPages,
    screenshotsEnabled,
    toggleScreenshotsEnabled,
    scale,
    onScaleChange,
    thumbnailPanelVisible,
    toggleThumbnailPanel,
}: ExtractionHeaderPropsType) => {
    return (
        <header className="extraction-header">
            <div className="extraction-header__item extraction-header__item--start gap-10">
                <Button
                    icon="sidebar"
                    active={thumbnailPanelVisible}
                    onClick={toggleThumbnailPanel}
                    title="Toggle thumbnail panel"
                />
                <PagesModeControls
                    pageMode={pageMode}
                    setPageMode={setPageMode}
                    screenshotsEnabled={screenshotsEnabled}
                    toggleScreenshotsEnabled={toggleScreenshotsEnabled}
                />
            </div>
            <div className="extraction-header__item extraction-header__item--middle">
                <FullPageNavigation
                    currentPage={currentPage}
                    handleNextPage={handleNextPage}
                    handlePrevPage={handlePrevPage}
                    handleSetPage={handleSetPage}
                    numberOfPages={numberOfPages}
                />
            </div>
            <div className="extraction-header__item extraction-header__item--end">
                <ScaleControl scale={scale} onScaleChange={onScaleChange} />
                <ExtractionsHistory completedExtractions={completedExtractions} />
            </div>
        </header>
    );
};

export default ExtractionHeader;
